import { service } from '@ember/service';
import Helper from '@ember/component/helper';

export default class ResolveUrlHelper extends Helper {
  @service router;

  compute([path]) {
    return this.router.rootURL + path;
  }
}
